<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div
        v-ripple
        class="d-flex justify-space-between align-center py-2"
        :class="$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'"
        :style="hover ? `color: #579FA75C; background-color: '#579FA71F'; cursor: pointer;` : ''"
        @click="$emit('showDetails', noShowAppointment)"
      >
        <div class="d-flex">
          <div class="pt-2 pr-3 profile__container--content__orderhistory--price">
            <v-icon color="primary">fxt-calendar-off</v-icon>
          </div>
          <div>
            <p class="font-weight-bold mb-0" :style="hover ? 'color: var(--v-primary-base)' : ''">
              {{ getDate(noShowAppointment.appointmentDate) }}: {{ formatTitle }}
            </p>
            <p class="mb-0" :style="hover ? 'color: var(--v-primary-base)' : ''">
              {{ noShowAppointment.siteName }}
            </p>
          </div>
        </div>
        <div class="d-flex profile__container--content__orderhistory--price">
          <p class="mb-0 pr-2" :class="!noShowAppointment.fairPayStatus === 4 ? 'text-decoration-line-through' : ''" :style="hover ? 'color: var(--v-primary-base)' : ''">
            {{ formatPrice(noShowAppointment.actualFee) }}
          </p>
        </div>
      </div>
    </v-hover>
    <hr class="profile__container--navigation__portal-linebreak"/>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    noShowAppointment: {
      required: true,
      type: Object,
      default: null,
    },
  },
  computed: {
    setFairPayStatus() {
      switch (this.noShowAppointment.fairPayStatus) {
          case 0: return 'UNKNOWN'; 
          case 1: return 'NEW'
          case 2: return 'REMINDER1'
          case 3: return 'REMINDER2'
          case 4: return 'PARDONED'
          case 5: return 'PAID'
      }
    },
    formatTitle() {
      let ret = this.noShowAppointment.treatmentNames
      let max = this.$vuetify.breakpoint.mdAndDown ? 30 : 50
      return ret.length > max ? ret.substring(0, max) + '...' : ret
    }
  },
  methods: {
    getDate(appointmentDate) {
      return new Date(appointmentDate).toLocaleDateString("no-NO", {
        year: "numeric",
        month: this.$vuetify.breakpoint.smAndDown ? "numeric" : "long",
        day: "numeric",
      });
    },
    formatPrice(price) {
      return price.toFixed(2).replace(".", ",");
    },
  },
};
</script>
